import React from "react";

import { Typography, Box } from "@mui/material";

export default function Typographies({ typographyData, context }) {
  return typographyData.map((d, didx) => {
    if (d.condition && !d.condition(context)) return null;
    if (d.type === "key")
      return <Box key={`typography-${didx}`}>{context.keys[d.key]}</Box>;
    if (["text", "subtitle", "subsubtitle"].includes(d.type)) {
      const props = {};
      if (["subtitle", "subsubtitle"].includes(d.type))
        props.color = "secondary";
      if (d.type === "subtitle") props.fontWeight = "bold";
      return (
        <Typography key={`typography-${didx}`} {...props}>
          {d.content}
        </Typography>
      );
    }
    if (d.type === "enumeration") {
      return (
        <Typography component="ul" key={`typography-${didx}`}>
          {d.content.map((t, tidx) => (
            <Typography key={`typography-${didx}-enum-${tidx}`} component="li">
              {t}
            </Typography>
          ))}
        </Typography>
      );
    }
    if (d.type === "space")
      return <Box sx={{ height: 10 }} key={`typography-${didx}`} />;
    return null;
  });
}
